/**
 * Декоратор для пометки полей, которые нужно упростить при сериализации.
 * При вызове toJSON() такие поля будут обработаны через Utils.simplifyObjectForServer()
 *
 * @example
 * class Product {
 *     @serializeSimplified
 *     buyer: Partner;
 * }
 */

function serializeSimplified(target: any, propertyKey: string): void {
	// Проверяем собственное поле класса, а не унаследованное по прототипу,
	// иначе поля наследника попадут в массив родителя
	if (!Object.hasOwn(target.constructor, '__simplifyFields')) {
		target.constructor.__simplifyFields = [];
	}

	/** Убираем приватный underscore _ , чтобы имя совпадало с публичным геттером */

	const publicName = propertyKey.startsWith('_')
		? propertyKey.slice(1)
		: propertyKey;
	target.constructor.__simplifyFields.push(publicName);
}

export default serializeSimplified;